<div
  class="grabber"
  tiimeGrabber
  (dragStarted)="handleDragStarted()"
  (dragMoved)="handleDragMoved($event)"
  (dragEnd)="handleDragEnded()"
>
  <mat-icon fontSet="fontastic" fontIcon="icon-cta-more-actions"></mat-icon>
</div>
